export default __webpack_public_path__ + "static/gashawk-92b10dfce53bf2d54c758a748e9545c9.jpeg";